<div class="ss-popup-bg">
  <div
    class="ss-popup-mask-bg"
    (click)="closeSecretSquirrelPopup($event)"
  ></div>
  <div [resizeDom]="layoutdataDesktop">
    <div
      class="ss-popup-inner-bg"
      (click)="closeSecretSquirrelPopup($event)"
    ></div>
    <img
      class="ss-bg-image"
      src="./assets/images/common/secret_squirrel@2x.webp"
    />
    <div class="ss-text" [resizeText]="25">Secret Squirrel</div>
    <div
      class="ss-cancel"
      [resizeText]="25"
      (click)="closeSecretSquirrelPopup($event)"
    >
      CANCEL
    </div>
    <div class="ss-decode" [resizeText]="25" (click)="onDecodeClick($event)">
      DECODE
    </div>
    <div class="ss-error" [resizeText]="18">{{ errorMsg }}</div>
    <input
      class="ss-pwd"
      type="text"
      name="defaultSSString"
      [resizeText]="18"
      maxlength="22"
      [(ngModel)]="defaultSSString"
      [placeholder]="placeholderString"
      (focus)="onSSInputFocus($event)"
    />
  </div>
</div>
